const CsvToJson = (csv) => {
  const lines = csv.split('\n')
  const result = []
  const headers = lines[0].split(';')

  for (var i = 1; i < lines.length; i++) {
	  var obj: any = {}
	  var currentline=lines[i].split(';')

	  for(var j = 0; j < headers.length; j++) {
		  obj[headers[j]] = currentline[j]
	  }

    // @ts-ignore
	  result.push(obj)
  }

  return result
}

export default CsvToJson
